import React from 'react'
import { render } from 'react-dom'
import App from './App'
// import MaestroPlayer from './MaestroPlayer'

const container = document.getElementById('app')

render(<App />, container)



// WEBPACK FOOTER //
// ./src/demo/index.js